import {Button, Card, Layout, Modal} from '@ui-kitten/components';
import React, {useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {px, wp} from '../../../../../utils';
import {CheckboxList, TitleRow} from '../../../../components';

const FilterModal = ({visible, onClose}) => {
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const grades = useSelector((state) => state.general.grades);
  const subjects = useSelector((state) => state.general.subjects);

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title="Timetable"
            type="primary"
            iconName="close-circle-outline"
            onIconClick={onClose}
            containerStyle={styles.title}
          />
          <ScrollView contentContainerStyle={styles.scrollView}>
            <CheckboxList
              title="Grade"
              list={grades?.map(({id: value, type: text}) => ({text, value}))}
              selectedItems={selectedGrades}
              setSelectedItems={setSelectedGrades}
            />
            <CheckboxList
              title="Subject"
              list={subjects?.map(({id: value, name: text}) => ({text, value}))}
              selectedItems={selectedSubjects}
              setSelectedItems={setSelectedSubjects}
              containerStyle={styles.marginTop}
            />
          </ScrollView>
          <Button style={styles.submitButton}>{'Confirm selection'}</Button>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    width: wp(90),
    height: px(600),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  scrollView: {
    paddingBottom: px(17),
  },
  title: {
    width: '100%',
  },
  marginTop: {
    marginTop: px(50),
  },
  submitButton: {
    margin: px(17),
    marginTop: px(30),
  },
});

export default FilterModal;
